<template>
  <header v-on:click="toggleNav">
    <div id="leftHeader" :style="flexibleContainer">  
      <transition name="logo-fade">
        <BLogoHeader v-show="navIsClosed" style="margin: 0px 14px 0px 14px;" />
      </transition>
        <transition name="logo-fade">
         <div id="logoTransDiv" v-show="navIsClosed">
          <h1>
            <b>BERG</b> ENTERPRISES
          </h1>
        </div>
      </transition>
      <div style="width: 0px;"></div> <!-- For flexbox centering -->
    </div>
    <div id="hamburgerFlex">
      <HamburgerButton />
    </div>
  </header>
</template>

<script>
import HamburgerButton from '../nav/HamburgerButton.vue'
import BLogoHeader from '../nav/BLogoHeader.vue'
  
export default {
  name: 'HeaderCompMobile',
  
  components: {
    HamburgerButton,
    BLogoHeader
  },
  
  data() {
    return {
      
    }
  },
  
  computed: {
    navIsClosed() {
      return !this.$store.state.nav.isOpen;
    },
    flexibleContainer() {
      if (this.navIsClosed) {
        return { width: '100%', 'max-width': '100%', 'min-width': '0%' };
      } else {
        return { width: 'calc(75% + 10px)', 'max-width': '300px', 'min-width': '240px' };
      }
    }
  },
  
  methods: {
    toggleNav() {
      this.$store.commit('toggleNav');
    }
  }
}
</script>

<style scoped>
  header {
    border: solid green 0px;
    background-image: linear-gradient(180deg, rgba(250,250,250,1) 0%, rgba(250,250,250,1) 1%, rgba(250,250,250,0.92) 10%, rgba(11,7,22,1) 90%, rgba(11,7,22,1) 91%, rgba(11,7,22,0.92) 100%);
    background-size: 100% 1000%;
    background-position: var(--nav-grad-pos);
    transition: background-position, 400ms;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    height: 60px;
    width: 100%;
    min-width: 320px;
    position: fixed;
    z-index: 70;
  }
  
  #leftHeader {
    border: solid green 0px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    transition: all 600ms cubic-bezier(.47,0,.32,1);
    max-width: 100%;
    min-width: 0%;
  }
  
  #hamburgerFlex {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  h1 {
    font-family: Futura,Trebuchet MS,Arial,sans-serif;
    font-weight: normal;
    font-size: 22px;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, .2);
    width: 214px;
    height: 30px;
    border: solid green 0px;
    text-align: center;
    margin: 0px;
    color: var(--logo-text);
    transition-duration: 1000ms;
  }
  
  #logoTransDiv {
    width: 214px;
    height: 30px;
    position: relative;
  }

  #logoText {
    width: 207px;
    height: 27px;
    transform: translateY(1px);
  }
  
  /* Vue Transitions */
  
  .logo-text-switch-enter-active {
    transition: all 200ms ease-in;
  }

  .logo-text-switch-leave-active {
    transition: all 200ms ease-out;
  }

  .logo-text-switch-enter, .header-switch-leave-to {
    opacity: 0;
  }
  
  .logo-fade-enter-active {
    transition: transform 600ms cubic-bezier(.47,0,.32,1), opacity 1000ms cubic-bezier(.47,0,.32,1);
    opacity: 1;
  }

  .logo-fade-leave-active {
    transition: transform 600ms cubic-bezier(.47,0,.32,1), opacity 300ms cubic-bezier(.47,0,.32,1);
    opacity: 0;
  }
  
  .logo-fade-enter, .logo-fade-leave-to {
    opacity: 0;
  }
</style>
